<template>
  <div class="users-main-wrapper" style="margin: 1rem 3rem 1rem 3rem">
    <div class="tab-content">
      <table class="table">
        <thead>
          <tr class="tr-info">
            <th>
              <input
                v-if="checkPermissions(auth, [1, 2, 3, 4, 5, 12])"
                v-model="selectAllUsersCheckbox"
                :title="'Select All users'"
                class="users-select-checkbox"
                type="checkbox"
                @click="selectAll"
              />
            </th>
            <th class="checkbox-cell">ID</th>
            <th></th>
            <th class="name-cell">Name</th>
            <th class="">Age</th>
            <th v-if="selectedTab === 'campaign stats'" class="">
              Top Country 1
            </th>
            <th v-if="selectedTab === 'campaign stats'" class="">
              Top Country 2
            </th>
            <th v-if="selectedTab === 'campaign stats'" class="">
              Top Campaign 1
            </th>
            <th v-if="selectedTab === 'campaign stats'" class="">
              Top Campaign 2
            </th>
            <th v-if="selectedTab === 'campaign stats'" class="">
              Top Keyword 1
            </th>
            <th v-if="selectedTab === 'campaign stats'" class="">
              Top Keyword 2
            </th>

            <th v-if="selectedTab === 'personal details'">Phone</th>
            <th v-if="selectedTab === 'personal details'">Address</th>
            <th v-if="selectedTab === 'personal details'">Birthday</th>
            <th v-if="selectedTab === 'personal details'">Bank Details</th>

            <th v-if="selectedTab === 'daily stats'">ASSIGNED</th>
            <th v-if="selectedTab === 'daily stats'">NEW</th>
            <th v-if="selectedTab === 'daily stats'">NR</th>
            <th v-if="selectedTab === 'daily stats'">NI</th>
            <th v-if="selectedTab === 'daily stats'">BN</th>
            <th v-if="selectedTab === 'daily stats'">NA</th>
            <th v-if="selectedTab === 'daily stats'">Leads</th>
            <th v-if="selectedTab === 'daily stats'">Referrals</th>
            <th v-if="selectedTab === 'daily stats'">Scheduled call</th>
            <th v-if="selectedTab === 'daily stats'">Missed scheduled calls</th>

            <th v-if="selectedTab === 'shift management'">Vacation</th>
            <th v-if="selectedTab === 'shift management'">Illness</th>
            <th v-if="selectedTab === 'shift management'">late</th>
            <th v-if="selectedTab === 'shift management'">OVER TIME</th>
            <th v-if="selectedTab === 'shift management'">
              total working hours
            </th>

            <th v-if="selectedTab === 'times'">Login</th>
            <th v-if="selectedTab === 'times'">Logout</th>
            <th v-if="selectedTab === 'times'">total duration of calls</th>
            <th v-if="selectedTab === 'times'">log</th>

            <th v-if="selectedTab === 'averages'">Average call time</th>
            <th v-if="selectedTab === 'averages'">Average New</th>
            <th v-if="selectedTab === 'averages'">
              Avg dep time from reg to deposit
            </th>
            <th v-if="selectedTab === 'averages'">
              Avg dep time from assigned to deposit
            </th>
            <th v-if="selectedTab === 'averages'">Avg transfer vs deposit</th>

            <th v-if="selectedTab === 'profitability'">Total Income</th>
            <th v-if="selectedTab === 'profitability'">last deposit date</th>
            <th v-if="selectedTab === 'profitability'">cost</th>
            <th v-if="selectedTab === 'profitability'">Phone cost</th>
            <th v-if="selectedTab === 'profitability'">other cost | email</th>
            <th v-if="selectedTab === 'profitability'">
              Average position cost
            </th>

            <th v-if="selectedTab === 'finance'">Salary live</th>
            <th v-if="selectedTab === 'finance'">Base salary</th>
            <th v-if="selectedTab === 'finance'">Bonuses</th>
            <th v-if="selectedTab === 'finance'">list of extra bonuses</th>
            <th v-if="selectedTab === 'finance'">amount of working days</th>
            <th v-if="selectedTab === 'finance'">last salary transferred</th>

            <th v-if="selectedTab === 'phone'">Amount of calls</th>
            <th v-if="selectedTab === 'phone'">total duration of calls</th>
            <th v-if="selectedTab === 'phone'">Top country 1</th>
            <th v-if="selectedTab === 'phone'">Top country 2</th>
            <th v-if="selectedTab === 'phone'">Top country 3</th>
            <th v-if="selectedTab === 'phone'">Cost</th>
            <th v-if="selectedTab === 'phone'">ext number - Configurations</th>

            <th v-if="selectedTab === 'goals'">Amount of FTD</th>
            <th v-if="selectedTab === 'goals'">Amount of CR</th>
            <th v-if="selectedTab === 'goals'">Amount of ProClub</th>
          </tr>
          <tr />
        </thead>
        <tbody>
          <tr v-for="(person, idx) in users" :key="idx" class="user-row">
            <td class="checkbox-cell">
              <template>
                <div class="client-checkbox-div">
                  <input
                    v-if="checkPermissions(auth, [1, 2, 3, 4, 5, 12])"
                    v-model="selectedUsers"
                    :value="person.id"
                    type="checkbox"
                  />
                </div>
              </template>
            </td>
            <td>#{{ person.id }}</td>
            <td class="flex"><img :src="person.profile_img" width="24" /></td>
            <td>
              {{ person.full_name }}
            </td>
            <td>{{ person.age }}</td>
            <td v-if="selectedTab === 'campaign stats'" class="">
              {{
                person.campaign_stats !== null
                  ? getCountry(person.campaign_stats.countries[0])
                  : "No Data"
              }}
            </td>
            <td v-if="selectedTab === 'campaign stats'" class="">
              {{
                person.campaign_stats !== null
                  ? getCountry(person.campaign_stats.countries[1])
                  : "No Data"
              }}
            </td>
            <td v-if="selectedTab === 'campaign stats'" class="">
              {{
                person.campaign_stats !== null
                  ? person.campaign_stats.camps[0]
                  : "No data"
              }}
            </td>
            <td v-if="selectedTab === 'campaign stats'" class="">
              {{
                person.campaign_stats !== null
                  ? person.campaign_stats.camps[1]
                  : "No data"
              }}
            </td>
            <td v-if="selectedTab === 'campaign stats'" class="">
              {{
                person.campaign_stats !== null
                  ? person.campaign_stats.keyWords[0]
                  : "No data"
              }}
            </td>
            <td v-if="selectedTab === 'campaign stats'" class="">
              {{
                person.campaign_stats !== null
                  ? person.campaign_stats.keyWords[1]
                  : "No data"
              }}
            </td>

            <td v-if="selectedTab === 'personal details'">
              {{ person.phone }}
            </td>
            <td v-if="selectedTab === 'personal details'">
              {{ person.address }}
            </td>
            <td v-if="selectedTab === 'personal details'">
              {{ person.birthday }}
            </td>
            <td v-if="selectedTab === 'personal details'">
              {{
                person.bank.length > 0 ? person.bank[0].bank_name : "no bank"
              }}
            </td>

            <td v-if="selectedTab === 'daily stats'">
              {{ person.daily_assignments.mine }} |
              {{ person.daily_assignments.all }} =
              {{
                calculateStat(
                  person.daily_assignments.mine,
                  person.daily_assignments.all
                )
              }}%
            </td>
            <td v-if="selectedTab === 'daily stats'">
              {{ person.daily_new_leads.mine }} |
              {{ person.daily_new_leads.all }} =
              {{
                calculateStat(
                  person.daily_new_leads.mine,
                  person.daily_new_leads.all
                )
              }}%
            </td>
            <td v-if="selectedTab === 'daily stats'">NR</td>
            <td v-if="selectedTab === 'daily stats'">
              {{ person.daily_ni.mine }} | {{ person.daily_ni.all }} =
              {{ calculateStat(person.daily_ni.mine, person.daily_ni.all) }}%
            </td>
            <td v-if="selectedTab === 'daily stats'">
              {{ person.daily_bad_numbers.mine }} |
              {{ person.daily_bad_numbers.all }} =
              {{
                calculateStat(
                  person.daily_bad_numbers.mine,
                  person.daily_bad_numbers.all
                )
              }}%
            </td>
            <td v-if="selectedTab === 'daily stats'">
              {{ person.daily_na.mine }} | {{ person.daily_na.all }} =
              {{ calculateStat(person.daily_na.mine, person.daily_na.all) }}%
            </td>
            <td v-if="selectedTab === 'daily stats'">
              {{ person.daily_leads.mine }} | {{ person.daily_leads.all }} =
              {{
                calculateStat(person.daily_leads.mine, person.daily_leads.all)
              }}%
            </td>
            <td v-if="selectedTab === 'daily stats'">
              {{ person.daily_referrals.mine }} |
              {{ person.daily_referrals.all }} =
              {{
                calculateStat(
                  person.daily_referrals.mine,
                  person.daily_referrals.all
                )
              }}%
            </td>
            <td v-if="selectedTab === 'daily stats'">
              {{ person.daily_scheduled_calls.mine }} |
              {{ person.daily_scheduled_calls.all }} =
              {{
                calculateStat(
                  person.daily_scheduled_calls.mine,
                  person.daily_scheduled_calls.all
                )
              }}%
            </td>
            <td v-if="selectedTab === 'daily stats'">Missed scheduled calls</td>

            <td v-if="selectedTab === 'shift management'">
              {{ person.vacation }}
            </td>
            <td v-if="selectedTab === 'shift management'">
              {{ person.illness }}
            </td>
            <td v-if="selectedTab === 'shift management'">late</td>
            <td v-if="selectedTab === 'shift management'">OVER TIME</td>
            <td v-if="selectedTab === 'shift management'">TWH</td>

            <td v-if="selectedTab === 'times'">
              {{ person.default_login !== null ? person.default_login : "No" }}
            </td>
            <td v-if="selectedTab === 'times'">
              {{
                person.default_logout !== null ? person.default_logout : "No"
              }}
            </td>
            <td v-if="selectedTab === 'times'">Total duration of calls</td>
            <td v-if="selectedTab === 'times'">log</td>

            <td v-if="selectedTab === 'averages'">Average call time</td>
            <td v-if="selectedTab === 'averages'">Average New</td>
            <td v-if="selectedTab === 'averages'">
              Avg dep time from reg to deposit
            </td>
            <td v-if="selectedTab === 'averages'">
              Avg dep time from assigned to deposit
            </td>
            <td v-if="selectedTab === 'averages'">Avg transfer vs deposit</td>

            <td v-if="selectedTab === 'profitability'">Total Income</td>
            <td v-if="selectedTab === 'profitability'">last deposit date</td>
            <td v-if="selectedTab === 'profitability'">cost</td>
            <td v-if="selectedTab === 'profitability'">Phone cost</td>
            <td v-if="selectedTab === 'profitability'">other cost | email</td>
            <td v-if="selectedTab === 'profitability'">
              Average position cost
            </td>

            <td v-if="selectedTab === 'finance'">Salary live</td>
            <td v-if="selectedTab === 'finance'">Base salary</td>
            <td v-if="selectedTab === 'finance'">Bonuses</td>
            <td v-if="selectedTab === 'finance'">list of extra bonuses</td>
            <td v-if="selectedTab === 'finance'">amount of working days</td>
            <td v-if="selectedTab === 'finance'">last salary transferred</td>

            <td v-if="selectedTab === 'phone'">Amount of calls</td>
            <td v-if="selectedTab === 'phone'">total duration of calls</td>
            <td v-if="selectedTab === 'phone'">Top country 1</td>
            <td v-if="selectedTab === 'phone'">Top country 2</td>
            <td v-if="selectedTab === 'phone'">Top country 3</td>
            <td v-if="selectedTab === 'phone'">Cost</td>
            <td v-if="selectedTab === 'phone'">ext number - Configurations</td>

            <td v-if="selectedTab === 'goals'">Amount of FTD</td>
            <td v-if="selectedTab === 'goals'">Amount of CR</td>
            <td v-if="selectedTab === 'goals'">Amount of ProClub</td>
          </tr>
        </tbody>
      </table>
    </div>
    <calendars-dashboard
      :query-object="{}"
      :selected-main-tab="'users'"
      :show-calendar="true"
    ></calendars-dashboard>
  </div>
</template>

<script>
import UserModel from "../utils/UserModel";
import { mapGetters, mapState } from "vuex";
import CalendarsDashboard from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/date_range_filtering_dashboard_v4/CalendarsDashboard";
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "UsersTable.container",
  // mixins: [UsersPermissionCheck, UsersStatsActiveScope, UsersActiveScope],

  components: {
    CalendarsDashboard
  },

  mounted() {
    this.getUsersTableData();
    // this.$emit("default_tab");
    // this.$emit("set-page");
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "loading"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },

  data() {
    return {
      usersTableData: [],
      selectedTab: "campaign stats",
      allSelectedInPage: false,
      selectAllUsersCheckbox: false,
      selectedUsers: [],
      users: [],
      pageNumInput: 1,
      campaign: null
    };
  },

  watch: {
    selectedTab() {
      //console.log(this.selectedTab)
    },
    usersTableData() {
      this.getUsers();
    }
  },

  methods: {
    getUsersTableData() {
      apiClientCreator("users/table")
        .get("")
        .then(res => {
          this.usersTableData = res.data.data;
        });
    },
    calculateStat(mine, all) {
      if (all == 0) {
        return "0";
      } else {
        return Math.round((mine / all) * 100);
      }
    },

    getCountry(id) {
      let name;
      this.dictionaries.general.countries.forEach(country => {
        if (country.id === id) {
          name = country.name;
        }
      });
      return name;
    },
    async getUsers() {
      let users = [];
      this.usersTableData.forEach(function(data) {
        users.push(new UserModel(data));
      });
      this.users = users;
    },

    selectAll() {
      if (!this.selectAllUsersCheckbox) {
        this.allSelectedInPage = true;
        let person;
        for (person in this.users) {
          this.selectedUsers.push(this.users[person].id);
        }
      }
      if (this.selectAllUsersCheckbox) {
        let selected = this.selectedUsers;
        this.users.forEach(user => {
          selected = selected.filter(item => item !== user.id);
        });
        this.selectedUsers = selected;
      }
    },

    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    }
  }
};
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.person-in-dropdown:hover {
  cursor: pointer;
  background-color: #3b86ff;
}

.person-in-dropdown {
  margin: 0.3rem;
}

.user-row:hover {
  background-color: #cdd6e3;
}

.users-select-checkbox {
  margin-left: 0.8rem;
  margin-right: 0.5rem;
  margin-top: 1.5rem;
  transform: translateY(-50%) translateX(-50%);
}

.name-cell {
  max-width: 135px;
  width: 135px;
}

.checkbox-cell {
  width: 20px;
  max-width: 20px;
}
th,
td {
  font-size: 13px;
  text-align: center;
}
th {
  font-weight: 700;
}
</style>
